<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useCheckoutFlow } from '@/composables/useCheckoutFlow';

const props = defineProps<{
  isStepValid: boolean;
  onStepComplete: () => void;
}>();

const { isStepLoading } = useCheckoutFlow();
const { t } = useI18n();
</script>

<template>
  <div class="juno-i18n-exclude sticky-next-step-container d-flex flex-column px-4">
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          block
          append-icon="mdi-arrow-right"
          color="primary"
          :disabled="!props.isStepValid"
          :loading="isStepLoading"
          @click="onStepComplete()">
          {{ t('common.actions.next') }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.sticky-next-step-container {
  position: sticky;
  bottom: 0;
  background: white;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
